<template>
  <el-dialog
    :visible.sync="visible"
    :title="$t('accountI18n.safeValiate')"
    width="400px"
    :close-on-click-modal="false"
    @close="handleClose"
    append-to-body
  >
    <div class="mag-box">
      <el-radio-group v-model="type" @change="changeType" style="margin-bottom: 10px;">
        <el-radio label="1">{{$t('accountI18n.phoneViate')}}</el-radio>
        <el-radio label="2">{{$t('accountI18n.emailViate')}}</el-radio>
      </el-radio-group>
      <el-form :model="safeForm" :rules="rules" ref="safeFormRef">
        <el-form-item
          v-if="type === '1'"
          :label="$t('accountI18n.phone')"
          prop="phone"
        >
          <el-input
            v-model="safeForm.phone"
            :placeholder="$t('accountI18n.phonePlaceholder')"
            maxlength="11"
            :disabled="userInfo ? true : false"
          />
        </el-form-item>
        <el-form-item
          v-if="type === '2'"
          :label="$t('accountI18n.email')"
          prop="email"
        >
          <el-input
            v-model="safeForm.email"
            :placeholder="$t('accountI18n.emailPlaceholder')"
            :disabled="userInfo ? true : false"
          />
        </el-form-item>
        <el-form-item :label="$t('accountI18n.code')" prop="code">
          <div class="justify-between">
            <el-input
              v-model="safeForm.code"
              :placeholder="$t('accountI18n.codePlaceholder')"
              maxlength="6"
            />
            <el-button
              :disabled="countdown > 0"
              @click="sendCode"
              style="margin-left: 10px;"
            >
              {{ countdown > 0 ? `${countdown}s ${$t('accountI18n.reSendCode')}` : $t('accountI18n.codeSend') }}
            </el-button>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('accountI18n.cancel')}}</el-button>
      <el-button type="primary" @click="submitCode">{{$t('accountI18n.confirm')}}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";
import { sendVerifyCode, updateAccount, verifyEmail, sendEmailCode, verifyPhone } from '@/api/index';
export default {
  name: "SafeValiate",
  props: {
    phone: {
      type: String,
      required: false
    },
    visible: {
      type: Boolean,
      required: true
    }
  },
  data() {
    // 校验规则
    const phoneValidator = (rule, value, callback) => {
      if (this.type === "1") {
        if (!value || !/^1\d{10}$/.test(value)) {
          callback(new Error(this.$t('accountI18n.phoneError')));
        } else {
          callback();
        }
      } else {
        if (
          !value ||
          !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)
        ) {
          callback(new Error(this.$t('accountI18n.emailError')));
        } else {
          callback();
        }
      }
    };
    const codeValidator = (rule, value, callback) => {
      if (!value || value.length !== 6) {
        callback(new Error(this.$t('accountI18n.codeError')));
      } else {
        callback();
      }
    };

    const emailValidator = (rule, value, callback) => {
      if (!value || !/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(value)) {
        callback(new Error(this.$t('accountI18n.emailError'))); 
      } else {
        callback(); 
      }
    }
    return {
      safeForm: {
        phone: "",
        code: "",
        email: ""
      },
      countdown: 0,
      type: "1",
      timer: null,
      rules: {
        phone: [{ validator: phoneValidator, trigger: "blur" }],
        email: [{ validator: emailValidator, trigger: "blur" }],
        code: [{ validator: codeValidator, trigger: "blur" }]
      },
      validation: ""
    };
  },
  watch: {
    visible(val) {
      if (!val) this.reset();
      this.type = "1";
      this.safeForm.phone = this.userInfo?.phone || "";
    }
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
    // 切换验证方式
    changeType() {
      if (this.type === "1") {
        this.safeForm.phone = this.userInfo?.phone || "";
      } else {
        this.safeForm.email = this.userInfo?.email || "";
      }
      this.safeForm.code = "";
      // 失焦，防止 aria-hidden 警告
      if (document.activeElement) {
        document.activeElement.blur();
      }
      if (this.timer) clearInterval(this.timer);
      this.countdown = 0
    },
    // 发送验证码
    sendCode() {
      this.countdown = 60;
      if (this.timer) clearInterval(this.timer);
      this.timer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
            clearInterval(this.timer);
            this.timer = null;
        }
      }, 1000);
      if(this.type === "1"){
        this.$refs.safeFormRef.validateField("phone", errorMessage => {
          if (errorMessage) return;
          sendVerifyCode({
              phone: this.safeForm.phone
          }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.$t('accountI18n.codeSendSuccess'));
            }else{
              this.$message.error(res.data.data); 
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.codeSendError')); 
          })
        });
      }else{
        this.$refs.safeFormRef.validateField("email", errorMessage => {
          if (errorMessage) return;
          sendEmailCode({ 
              email: this.safeForm.email
          }).then(res => {
            if (res.data.code == 200) {
              this.$message.success(this.$t('accountI18n.codeSendSuccess'));
            }else{
              this.$message.error(res.data.data); 
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.codeSendError')); 
          })
        });
      }
    },
    // 提交验证
    submitCode() {
      this.$refs.safeFormRef.validate(valid => {
        if (!valid) return;
        if(this.type === "1"){
          verifyPhone(this.safeForm.phone, {
            security_code: this.safeForm.code,
          }).then(res => {
            if (res.data.code == 200) {
              this.validation = res.data.data.validation
              this.$emit("success", this.type, this.validation, this.safeForm.phone);
              this.reset();
            } else {
              this.$message.error(res.data.data);
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.codeSendError')); 
          })
        }else{
          verifyEmail(this.safeForm.email, {
            security_code: this.safeForm.code
          }).then(res => {
            if (res.data.code == 200) {
              this.validation = res.data.data.validation
              this.$emit("success", this.type, this.validation, this.safeForm.email);
              this.reset();
            } else {
              this.$message.error(res.data.data);
            }
          }).catch(err => {
            this.$message.error(err || this.$t('accountI18n.codeSendError')); 
          })
          }
      });
    },
    // 关闭弹窗
    handleClose() {
      this.$emit("close");
      this.reset();
    },
    // 重置状态
    reset() {
      this.$refs.safeFormRef.resetFields();
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
      this.countdown = 0;
    }
  },
  beforeDestroy() {
    if (this.timer) clearInterval(this.timer);
  }
};
</script>
<style>
.mag-box .el-radio__inner{
  width: 18px!important;
  height: 18px!important; 
}

.mag-box .el-radio__label{
  font-size: 18px!important; 
}

.mag-box .el-radio__input{
  vertical-align: text-top!important;
}
.mag-box .el-form-item__label{
  font-size: 18px!important;
}

.mag-box .el-input__inner{
  font-size: 18px!important;
}

.mag-box .el-button .el-button--default{
  font-size: 18px!important; 
}

.mag-box .el-button .el-button--primary{
  font-size: 18px!important; 
}

.el-button{
  font-size: 18px!important;
}
</style>